import { render, staticRenderFns } from "./location-read-emails.vue?vue&type=template&id=4df18c91&scoped=true"
import script from "./location-read-emails.vue?vue&type=script&lang=js"
export * from "./location-read-emails.vue?vue&type=script&lang=js"
import style0 from "./location-read-emails.vue?vue&type=style&index=0&id=4df18c91&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df18c91",
  null
  
)

export default component.exports